export const NAV_ROUTES = [
  {
    id: 'clothes',
    to: 'clothes',
    text: 'CLOTHES'
  },
  { id: 'fit', to: 'fit', text: 'FIT' }
];
